import React, { useEffect, useState } from "react";
import { company_logo, knf_logo, logo, profile } from "../../assets/imgs";
import { useLazyViewAdminQuery } from "../../screens/redux/api/api";
import apiRequest from "../../screens/redux/api/apiRequest";

const Topbar = ({ setRoleText, roleText }) => {
  const [saideBarShow, setSaidBarShow] = useState(true);
  const userdata = JSON.parse(localStorage.getItem("user_details"));
  const logindata = JSON.parse(localStorage.getItem("loginData"));
  const userlogo = JSON.parse(localStorage.getItem("company"));
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [viewAdmin] = useLazyViewAdminQuery();
  const loginType = localStorage.getItem("type");

  const getUserdata = async (id) => {
    const res = await apiRequest(viewAdmin, id);
    if (res?.status == "success") {
      // givenpermissions?.length != res?.permission
    }
    console.log(res);
  };

  useEffect(() => {
    if (userdata?.id) {
      // getUserdata(userdata?.id);
    }
  }, []);

  // console.log("userlogo", userlogo);

  return (
    <div className="d-flex ac-jb topbar">
      <div className="d-flex ac-jc">
        {logindata?.role == "Super Admin" &&
          logindata?.knf_role == "Knf Super Admin" && (
            <div className="image_text pointer mt-1 me-2">
              <div className="d-flex ac-js">
                <img src={logo} className="admin-logo" alt="" />
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                  {userlogo?.name ? userlogo?.name : " KNF WAS@SG"}
                </h2>
              </div>
              <img src={knf_logo} className="knf-logo" alt="" />
            </div>
          )}
        {userdata?.role?.id &&
          !userdata?.knf_role?.id &&
          logindata?.role !== "Super Admin" &&
          logindata?.knf_role !== "Knf Super Admin" && (
            <div className="d-flex ac-js">
              <img
                src={userlogo?.logo ? userlogo?.logo : logo}
                className="admin-logo"
                alt=""
              />
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                {userlogo?.name ? userlogo?.name : " KNF WAS@SG"}
              </h2>
            </div>
          )}

        {userdata?.knf_role?.id &&
          !userdata?.role?.id &&
          logindata?.role !== "Super Admin" &&
          logindata?.knf_role !== "Knf Super Admin" && (
            <div className="image_text pointer mt-1 me-2">
              <img src={knf_logo} className="knf-logo" alt="" />
            </div>
          )}

        {userdata?.role?.id &&
          userdata?.knf_role?.id &&
          logindata?.role !== "Super Admin" &&
          logindata?.knf_role !== "Knf Super Admin" && (
            <div className="d-flex ac-js">
              <img
                src={userlogo?.logo ? userlogo?.logo : logo}
                className="admin-logo"
                alt=""
              />
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                {userlogo?.name ? userlogo?.name : " KNF WAS@SG"}
              </h2>
            </div>
          )}

        {logindata?.role !== "Super Admin" &&
          logindata?.knf_role !== "Knf Super Admin" &&
          !userdata?.role?.id &&
          !userdata?.knf_role?.id &&
          userdata?.knf_type >= 1 &&
          userdata?.knf_type <= 5 && (
            <>
              {/* <div className="image_text pointer mt-1 me-2"> */}
              {/* <img src={knf_logo} className="knf-logo" alt="" /> */}
              <div className="d-flex ac-js">
                <img
                  src={
                    logindata?.company?.logo ? logindata?.company?.logo : logo
                  }
                  className="admin-logo"
                  alt=""
                />
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                  {logindata?.company?.name ? logindata?.company?.name : ""}
                </h2>
              </div>
              {/* </div> */}
            </>
          )}
        {/*<div className="d-flex">
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 border-right pe-3 mb-0">
              Creating Space
            </p>
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ps-3 mb-0">
              Creating Home
            </p>
          </div> */}
      </div>
      <div className="d-flex ac-jc">
        <img
          src={userdata?.profile_image ? userdata?.profile_image : profile}
          className="profile-img me-2"
          alt=""
        />
        <div>
          <h2 className="f3  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 text-nowrap">
            Welcome: {userdata?.name}
          </h2>
          <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 text-nowrap">
            Role :
            <span className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              {" "}
              {roleText == "knf"
                ? userdata?.role?.name
                  ? userdata?.role?.name
                  : loginType == "Company Sub Admin"
                  ? "SubAdmin"
                  : loginType == "Company User"
                  ? "User"
                  : "Company Manager"
                : roleText == "aiware"
                ? userdata?.knf_role?.name
                  ? userdata?.knf_role?.name == "Knf Super Admin"
                    ? "Super Admin"
                    : userdata?.knf_role?.name == "Knf Company Admin"
                    ? "Company Manager"
                    : userdata?.knf_role?.name
                  : userdata?.knf_type == 2
                  ? "Site Admin"
                  : userdata?.knf_type == 3
                  ? "Group User 1"
                  : userdata?.knf_type == 4
                  ? "Group User 2"
                  : userdata?.knf_type == 5
                  ? "Group User 3"
                  : "Company Manager"
                : userdata?.role?.name
                ? userdata?.role?.name
                : loginType == "Company Sub Admin"
                ? "SubAdmin"
                : loginType == "Company User"
                ? "User"
                : userdata?.knf_role?.name
                ? userdata?.knf_role?.name == "Knf Super Admin"
                  ? "Super Admin"
                  : userdata?.knf_role?.name == "Knf Company Admin"
                  ? "Company Manager"
                  : userdata?.knf_role?.name
                : userdata?.knf_type == 2
                ? "Site Admin"
                : userdata?.knf_type == 3
                ? "Group User 1"
                : userdata?.knf_type == 4
                ? "Group User 2"
                : userdata?.knf_type == 5
                ? "Group User 3"
                : "Company Manager"}
              {/* {userdata?.role?.name
                ? userdata?.role?.name
                : userdata?.knf_role?.name
                ? // ? userdata?.knf_role?.name
                  "Company Manager"
                : userdata?.knf_type == 2
                ? "Site Admin"
                : userdata?.knf_type == 3
                ? "Group User 1"
                : userdata?.knf_type == 4
                ? "Group User 2"
                : userdata?.knf_type == 5
                ? "Group User 3"
                : ""} */}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
